/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：23
 */

export { locale as b }
export { messages as e }
export { f as a }
export { format as c }
export { g as f }
export { _ as d }
import * as /* [auto-meaningful-name] */Module_6 from /* 6 */"../../../unrestored/shared/1571/2636/6"
import React from "react"
import { createIntl } from "react-intl"
import * as /* [auto-meaningful-name] */Module_10 from /* 10 */"../../../unrestored/shared/1571/2636/10/index"
var c = {
  mustToBeString: "{name} 必须是字符串",
  mustToBeNumber: "{name} 必须是数值",
  mustToBeBoolean: "{name} 必须是布尔值",
  valueOutOfRange: "嵌入积木数值超过取值范围",
  opacityValueOutOfRange: "透明度超出极值范围，已按极值处理",
  scaleOutOfRange: "比例大小超过极值范围",
  opacityOutOfRange: "透明度超过极值范围",
  onWidgetPress: "被点击",
  onWidgetPressIn: "被按下",
  onWidgetPressOut: "被松开",
  onWidgetPressHold: "被按住",
  onWidgetSelected: "完成选择",
  onInputFocus: "获取焦点",
  onInputBlur: "失去焦点",
  imageNotExists: "找不到对应的图片资源",
  colorError: "嵌入积木的返回值不是颜色值类型",
  onRadioSelected: "的第{index}项被选中",
  getExceedingTheMaximumLimitOfRadio: "{name}: 不存在第{index}项",
  setExceedingTheMaximumLimitOfRadio: "{name}: 最多可设置八项,最少设置1项",
  indexOutOfRange: "{name}: 第{index}项 在{name}中不存在",
  emptyContent: " {name}: 该项数的选中内容参数为空",
  outMaxRange: "当前已达 {name} 最大值 8个，无法继续添加",
  onCheckboxSelected: "的第{index}项被选中",
  onCheckboxUnselected: "的第{index}项被取消选中",
  onWebViewUrlStartLoad: "开始加载",
  onWebViewUrlLoaded: "加载完成",
  onWebViewUrlLoadError: "加载失败",
  onSwitchChangeTrue: "状态变为开启",
  onSwitchChangeFalse: "状态变为关闭",
  onSliderStartSlide: "在{value}的位置开始滑动",
  onSliderEndSlide: "在{value}的位置结束滑动",
  sliderValueOutOfRange: "滑块位置超过取值范围",
  sliderMaxValueOrMinValueOutOfRange: "最大值或最小值超过取值范围",
  sliderMaxValueEqualMinValue: "最大值与最小值相等",
  onListViewerIndexPress: "的第{index}行被点击",
  gridColumnNotExists: "绑定的列不存在，请选择数据源的表头名称进行绑定",
  gridRowNotExists: "行数超出数据源范围",
  listViewerNoDataSource: "列表数据框没有绑定数据源",
  listViewerDataSourceNotExists: "列表数据框绑定的数据源不存在",
  listViewerDataSourceFetchError: "绑定的云数据源获取失败（{msg}）",
  actorActionNameNotExists: "设置的动作名称不存在",
  actorStyleIndexNotExists: "设置的造型编号不存在",
  soundBlockValueTypeError: "所嵌入积木的返回值不是数字类型",
  soundBlockNoSelectFile: "播放声音积木没有选择音频文件",
  cameraTakePhotoFail: "相机没有权限拍照",
  cameraTakeVideoFail: "相机没有权限录像",
  cameraPhotoFailChoose: "相册没有权限",
  cameraNotSupportError: "硬件不支持：该设备不支持没有摄像头",
  videoNotSupportTips: "网页端不支持录像功能，请打包后使用",
  onGyroscopeShake: "手机 被摇晃",
  overflowStack: "函数递归调用次数过多，调用栈溢出；",
  widgetNotExists: "积木无对应控件",
  widgetDisabled: "积木 {name} 对应控件被禁用",
  notArray: "无对应列表数据，请创建列表",
  variableOutRange: "您选择的第{index}项在该列表中不存在",
  errorArrayType: "数据类型错误，仅支持列表类型运行",
  argNotNumber: "{name} 嵌入积木的返回值不是数值类型",
  argNotColor: "嵌入积木的返回值不是颜色值类型",
  keyNotExists: "{key}键已删除或不存在，找不到对应{key}键",
  notNetwork: "网络通讯异常，无法{type} {key}的值",
  deleteNotNetwork: "网络通讯异常，无法{type} {key}和值",
  localStorageInvalidKeyType: "嵌入积木的返回值不是字符串类型",
  localStorageInvalidValueType: "嵌入积木的返回值不是字符串类型",
  cloudStorageInvalidValueType: "数据类型不合法，云微数据库的值的类型只能为字符串或数字",
  httpOnWeakNetworkTips: "当前网络较差，请检查网络",
  additionArgumentTypeError: "加法积木只能嵌入数字或字符串类型",
  operationArgumentTypeError: "数学运算积木只能嵌入数字类型",
  brightnessTypeError: "屏幕亮度范围为[0,100]，请输入数字类型。",
  brightnessLessThan: "屏幕亮度最大值为100，请设置正确的数字。",
  brightnessGreaterThan: "屏幕亮度最小值为0，请设置正确的数字。",
  brightnessKeepScreenOnNotSupported: "设置屏幕常亮积木在网页端没有效果，打包后可以正常使用。",
  columnNotExists: "找不到当前列",
  rowNotExists: "找不到当前行",
  objectRepeatKey: "键名重复，键名相同时以最后一次设置为准",
  objectKeyNotExist: "字典不存在该键",
  objectTypeError: "数据类型错误，仅支持字典类型运行",
  objectNotExist: "无对应字典数据，请创建字典",
  objectKeyTypeError: "字典的键只支持字符串或数值类型",
  screenIndexNotExist: "切换的屏幕序号不存在",
  screenTitleNotExist: "切换的屏幕名称不存在",
  screenTypeNotNumberAndString: "嵌入积木的返回值不是数值/字符串类型",
  cloudTableDataSourceNotExist: "未绑定数据源"
}
var l = function () {
  var e = {}
  Object.entries(c).forEach(function (t) {
    var n = Module_10.a(t, 2)
    var r = n[0]
    var o = n[1]
    return e["player/" + r] = o
  })
  return e
}()
var u = Module_6.a(Module_6.a({}, {
  run: "运行",
  save: "保存",
  notSave: "不保存",
  publish: "发布",
  play: "运行",
  playFirstScreen: "从首屏开始",
  playCurrentScreen: "从当前屏幕开始",
  stop: "停止",
  package: "打包",
  program: "编程",
  property: "属性",
  components: "界面控件",
  allComponents: "控件集成",
  allButton: "所有按钮",
  allInput: "所有输入框",
  allText: "所有文本",
  widgetList: "控件列表",
  basicBlock: "通用积木",
  invisibleWidgetList: "屏幕功能控件",
  globalWidgetList: "全局功能控件",
  anyWidgetAny: "任意",
  anyWidgetList: "任意控件",
  cloudDBManager: "云数据管理",
  "Widget.basic": "基础",
  "Widget.extension": "拓展",
  "Widget.emptyTip1": "暂未添加控件",
  "Widget.emptyTip2": "请到控件商城添加",
  "Widget.widgetMall": "控件商城",
  "Widget.removeWidget": "移除控件",
  "WidgetMall.clear": "清空",
  "WidgetMall.add": "添加",
  "WidgetMall.networkError": "当前网络不佳，暂无法获取，请检查网络后重试",
  "WidgetMall.retry": "重新加载",
  "WidgetMall.addSuccess": "添加控件成功",
  "WidgetMall.addFailure": "控件添加失败，网络不佳，请稍后再试",
  "WidgetMall.removeSuccess": "移除控件成功",
  "WidgetMall.removeFailure": "移除控件失败，网络不佳，请稍后再试",
  "WidgetMall.added": "已添加",
  "ExtensionWidget.dialogTitle": "自定义控件 {title}（{type}） 已存在，是否进行覆盖？",
  "ExtensionWidget.overwrite": "覆盖",
  "ExtensionWidget.loading": "正在加载控件...",
  "ExtensionWidget.finishRegistration": "控件 {title}（{type}） 加载完成",
  /** [CoCo Next] 移除自定义控件 */
  "ExtensionWidget.finishRemove": "已移除控件 {title}（{type}）",
  "ExtensionWidget.category.ui": "界面控件",
  "ExtensionWidget.category.function": "功能控件",
  "ExtensionWidget.category.extension": "自定义控件",
  "WidgetList.category.ui": "用户界面",
  "WidgetList.category.stage": "绘图动画",
  "WidgetList.category.media": "多媒体",
  "WidgetList.category.dateTime": "日期时间",
  "WidgetList.category.sensor": "传感器",
  "WidgetList.category.localStorage": "本地存储",
  "WidgetList.category.cloudStorage": "云存储",
  "WidgetList.category.cloudSpace": "云存储",
  "WidgetList.category.network": "通讯连接",
  "WidgetList.category.grid": "表格",
  "WidgetList.category.social": "社交",
  "WidgetList.addSuccessToast": "已添加「{widgetTitle}」控件",
  "WidgetList.addFailureToast": "控件添加失败，请稍后再试",
  /** [CoCo Next] 移除自定义控件 */
  "WidgetList.widgetIsUsedTitle": "控件正在使用",
  "WidgetList.widgetIsUsedContent": "控件「{title}」正在使用，移除控件可能导致作品异常。\n确定要移除该控件吗？",
  "WidgetList.removeSuccess": "已移除「{title}」控件",
  "TextWidget.widgetName": "文本",
  "ButtonWidget.widgetName": "按钮",
  "InputWidget.widgetName": "输入框",
  "ListViewerWidget.widgetName": "列表数据框",
  "GridViewerWidget.widgetName": "网格数据框",
  "ListViewerWidget.dataSource": "数据源",
  "ListViewerWidget.localTableData": "本地数据表",
  "ListViewerWidget.dataSourcePlaceholder": "请选择数据源",
  "ListViewerWidget.importNewSource": "导入文件",
  "ListViewerWidget.dataBindings": "数据绑定",
  "ListViewerWidget.dataBindingsPlaceholder": "请选择数据列",
  "ListViewerWidget.templateType": "条目样式",
  "ListViewerWidget.tiled": "平铺",
  "ListViewerWidget.card": "卡片",
  "ListViewerWidget.title": "标题",
  "ListViewerWidget.subTitle": "副标题",
  "ListViewerWidget.longTitle": "这是一段标题文案，最多显示两行。这是一段标题文案，最多显示两行。",
  "ListViewerWidget.tips": "提示文案",
  "ListViewerWidget.input": "输入文案",
  "ListViewerWidget.desc": "说明文本",
  "ListViewerWidget.longDesc": "这是一段说明文案，最多显示两行。这是一段说明文案，最多显示两行。",
  "ListViewerWidget.image": "图片",
  "ListViewerWidget.avatar": "头像",
  "ListViewerWidget.banner": "主图",
  "ListViewerWidget.createDataSource": "新建数据源",
  "ListViewerWidget.createCloudTable": "新建云数据表",
  "ListViewerWidget.tableData": "数据表",
  "ListViewerWidget.tableDataDesc": "方便快捷 保存本地",
  "ListViewerWidget.cloudTable": "云数据表",
  "ListViewerWidget.cloudTableDesc": "云端共享 共同协作",
  "ListViewerWidget.cloudTableOtTips": "仅创作者可进行此操作",
  "ListViewerWidget.vikaTable": "维格云表",
  "ListViewerWidget.vikaTableDesc": "拓展控件 功能全面",
  "ListViewerWidget.moreTableDataTips": "敬请期待",
  "ListViewerWidget.imageNotExists": "绑定数据表找不到对应图片资源",
  "ListViewerWidget.toCloudSpaceDomain": "前往源码云空间",
  "ListViewerWidget.toCloudSpaceDomainTips": "云数据源新建编辑需跳转至源码云空间，工具内仅支持云数据源绑定功能",
  "CameraWidget.widgetName": "照相机",
  "AudioWidget.widgetName": "音频播放",
  "AudioWidget.source": "音源",
  "AudioWidget.volume": "音量",
  "AudioWidget.rate": "音速",
  "GyroscopeWidget.widgetName": "陀螺仪",
  "VolumeSensorWidget.widgetName": "环境音量",
  "DatePickerWidget.widgetName": "日期选择",
  "TimePickerWidget.widgetName": "时间选择",
  "TimerWidget.widgetName": "计时器",
  "HttpClientWidget.widgetName": "HTTP客户端",
  "HttpClientWidget.url": "网址",
  "HttpClientWidget.header": "请求头",
  "HttpClientWidget.params": "GET请求参数",
  "HttpClientWidget.body": "POST请求文本",
  "CloudRoomWidget.widgetName": "云房间",
  "LocalStorageWidget.widgetName": "微数据库",
  "CloudStorageWidget.widgetName": "云微数据库",
  "CloudDbWidget.widgetName": "云数据库",
  "GridWidget.widgetName": "表格",
  "TableDataWidget.widgetName": "数据表",
  "CloudSpaceDictWidget.widgetName": "云字典",
  "CloudSpaceDBWidget.widgetName": "云数据表",
  repeatGridColumnName: "当前列名和其他列名重名，请修改",
  maximumGridSourceSize: "表格文件大小不能超过5MB",
  uploadGridSuccess: "表格导入成功",
  copySuccess: "内容已复制",
  emptyColumn: "当前列为空",
  emptyColumnName: "列名不能为空",
  pasteColumnOutOfRange: "粘贴内容超过当前列数，超出部分不粘贴",
  columnLengthLimit: "最多创建50列",
  rowLengthLimit: "最多创建{num}行",
  addColumnFirst: "请先添加列",
  gridSupportTypeTips: "* 数据表存储的值均为字符串数据类型",
  "TableDataWidget.data": "初始数据",
  row: "行",
  column: "列",
  addRowTips: "新增行",
  saveTipsTitle: "是否保存当前修改？",
  saveTipsDesc: "您尚未保存内容，直接离开将会丢失已编辑内容。",
  "cloudGrid.FileSizeLimit": "最多支持5M的文件",
  "cloudGrid.FileColumnSizeLimit": "最多支持10列的文件输入",
  "cloudGrid.FileColumnNameRepeat": "不能导入列名重复的文件",
  "cloudGrid.FileRowSizeLimit": "最多支持500行的文件输入",
  "cloudGrid.FileCellSizeLimit": "每个单元格最多支持输入1000个字符",
  "cloudGrid.FileImport": "导入文件",
  "cloudGrid.uniqueColumn": "指定唯一列",
  "cloudGrid.uniqueColumnTipsContent": "设置为唯一列后，数据不可重复",
  "cloudGrid.importTipsContent1": "支持xls、xlsx、csv文件",
  "cloudGrid.importTipsContent2": "只能导入小于5MB的文件",
  "cloudGrid.importTipsContent3": "只能导入小于10列、500行的文件",
  "cloudGrid.testData": "测试数据",
  "cloudGrid.prodData": "正式数据",
  "cloudGrid.loading": "数据加载中...",
  "cloudGrid.selectPlaceholder": "请选择数据列",
  "cloudGrid.EmptyColumnTitle": "提示",
  "cloudGrid.EmptyColumnContent": "部分列名为空，保存后将自动删除一整列。\n如果想要保留该列，请返回修改列名。",
  "cloudGrid.continueSave": "继续保存",
  "cloudGrid.returnEdit": "返回修改",
  "cloudGrid.tips": "提示",
  "cloudGrid.confirm": "确定",
  "cloudGrid.save": "保存",
  "cloudGrid.cancel": "取消",
  "cloudGrid.uniqueColumnEmptyTitle": "错误",
  "cloudGrid.uniqueColumnEmptyContent": "唯一列的数据不能为空",
  "cloudGrid.booleanCheckNotice": "请输入布尔值的数据",
  "cloudGrid.numberCheckNotice": "请输入数字型的数据",
  "cloudGrid.commonCheckNotice": "输入有误，请重新修改",
  "cloudGrid.uniqueColumnError": "唯一列数据不能重复",
  "cloudGrid.unSaveNotice": "数据暂未保存，是否退出编辑？",
  "cloudGrid.fileImportSuccess": "表格导入成功",
  "cloudGrid.importCoverTitle": "提示",
  "cloudGrid.importCoverTitleContent": "导入文件会覆盖已有数据，确定继续导入？",
  "cloudDBWidget.data": "数据",
  "cloudDBWidget.loading": "数据加载中...",
  "cloudDBWidget.tipsContent": "这里的数据是仅在编辑器内使用的测试数据",
  "cloudDb.defaultName": "云数据库",
  "cloudDb.noLoginError": "未登录情况下无法加载云数据库，已经删除云数据库，请登录后重新加载文件",
  "cloudDb.dataRemoveTitle": "提示",
  "cloudDb.dataRemoveContent": "数据库不存在，已经为你去除",
  "cloudDb.dataChangeNotice": "数据库信息与云端信息不符合，已经为你更改",
  "cloudDb.know": "知道了",
  "cloudDBManager.title": "云数据管理器",
  "cloudDBManager.capacity": "云服务器容量",
  "cloudDBManager.testData": "测试数据",
  "cloudDBManager.prodData": "正式数据",
  "cloudDBManager.delete": "删除",
  "cloudDBManager.import": "引用",
  "cloudDBManager.hasImport": "已引用",
  "cloudDBManager.usedCapacity": "已用容量",
  "cloudDBManager.editData": "修改数据",
  "cloudDBManager.deleteTitle": "警告",
  "cloudDBManager.deleteImportContent": "当前数据库在本作品有引用，请解除引用再删除",
  "cloudDBManager.deleteContent": "当前数据库有其他作品引用，删除后其他作品运行可能存在问题，是否继续删除?",
  "cloudDBManager.editTitle": "提示",
  "cloudDBManager.editNotice": "修改正式数据将会影响已发布的线上作品数据，请谨慎操作!",
  "cloudDBManager.editBtn": "修改",
  "cloudDBManager.noCloudDB": "还未创建云数据库",
  "cloudDBManager.noDataDev": "当前数据库没有数据",
  "cloudDBManager.noDataProd": "当前没有正式数据，打包分享后才会生成哦～",
  "cloudDBWidget.generateError": "数据库容量已满，无法创建新的数据库",
  copyGridData: "复制",
  pasteGridData: "粘贴",
  deleteGridData: "删除列",
  deleteRowData: "删除行",
  clearGridData: "清空内容",
  clearData: "清除内容",
  insertPrevRow: "向上插入一行",
  insertNextRow: "向下插入一行",
  numberGridData: "数字",
  stringGridData: "字符串",
  booleanGridData: "布尔值",
  event: "事件",
  control: "控制",
  feature: "功能",
  audio: "声音",
  operators: "运算",
  variable: "变量",
  editDefaultValue: "编辑初始值",
  list: "列表",
  keyValue: "键值对",
  procedures: "函数",
  sensing: "侦测",
  communication: "通信",
  object: "字典",
  initValue: "初始值",
  untitled: "未命名",
  componentList: "组件列表",
  textColor: "文本颜色",
  textOverflow: "溢出文本框时隐藏",
  backgroundColor: "背景颜色",
  backgroundImage: "背景图片",
  fontFamily: "字体",
  fontSize: "字号",
  fillColor: "填充颜色",
  align: "对齐",
  button: "按钮",
  content: "文案",
  horizontalAlignment: "水平对齐",
  verticalAlignment: "垂直对齐",
  alignment: "对齐方式",
  edit: "编辑",
  show: "显示",
  hide: "隐藏",
  size: "尺寸",
  width: "宽",
  height: "高",
  coordinate: "坐标",
  styleCenterCoordinate: "造型中心坐标",
  relativeCoordinate: "相对坐标",
  text: "文本",
  brushPenSize: "粗细",
  brushPenColor: "颜色",
  brushCursorShape: "光标形状",
  drawProcess: "绘画过程",
  drawSpeed: "绘画速度",
  drawSpeedUnit: " px/s",
  defaultTextWidgetContent: "文本",
  defaultButtonWidgetContent: "按钮",
  defaultInputWidgetContent: "请输入内容",
  defaultScreenTitle: "屏幕1",
  invalidVariableNoValue: "名称不能为空",
  invalidVariableName: "只支持字母、汉字、数字和下划线",
  invalidVariableFirstChar: "首个字符不能为数字或下划线",
  invalidVariableMaxLengthTips: "名称长度最多支持20个字符",
  isEmptyKey: "键不能为空",
  addPrimitiveVariableName: "新建变量",
  addPrimitiveVariableNamePlaceholder: "请输入变量名称",
  addArrayVariableName: "新建列表",
  addArrayVariableNamePlaceholder: "请输入列表名称",
  arrayVariableNameRepeat: "列表名已存在",
  primitiveVariableNameRepeat: "变量名已存在",
  storageNameRepeat: "微数据库名已存在",
  addGridName: "新建表格",
  addGridNamePlaceholder: "请输入表格名称",
  gridNameRepeat: "表格名已存在",
  name: "名称",
  confirm: "确定",
  deny: "拒绝",
  cancel: "取消",
  retry: "重试",
  editVariableList: "编辑列表",
  editStorage: "编辑微数据库",
  itemCount: "项数",
  variableListEmptyContentLabel: "当前内容为空",
  able: "启用",
  disabled: "禁用",
  color: "颜色",
  tinySize: "超小",
  smallSize: "小",
  mediumSize: "中",
  largeSize: "大",
  hugeSize: "超大",
  mode: "类型",
  icon: "图标",
  background: "背景样式",
  template: "模板",
  templateColor: "模板颜色",
  delete: "删除",
  deleteScreen: "删除屏幕",
  deleteWidget: "删除控件",
  addScreen: "添加屏幕",
  screenManage: "屏幕",
  deleteScreenTips: "屏幕的所有控件和积木也会被同时删除",
  deleteWidgetTips: "该控件相关的积木会失效",
  deleteParentWidgetTips: "该控件及其子控件相关的积木会失效",
  contain: "全显",
  cover: "裁剪",
  stretch: "拉伸",
  image: "图片",
  imageBox: "图片框",
  defaultImageWidgetTitle: "图片框",
  adapt: "适配",
  tooLargeImage: "图片不能大于5MB",
  tooLargeGifImage: "gif动图不能大于10MB",
  imageNameError: "图片名称不能为空",
  illegalFormat: "格式错误",
  uploadImageFile: "本地上传",
  selectByLibrary: "素材库选择",
  selectByIconLibrary: "图标库选择",
  emptyImage: "空",
  resourceLibrary: "资源库",
  materialLibrary: "素材库",
  imageLibrary: "图片库",
  widgetManage: "控件管理",
  resourceManage: "资源管理",
  radioGroup: "单选框",
  "HeaderDropdown.more": "展开菜单",
  // [CoCo Next] 把“电脑”改为“本地”
  "HeaderDropdown.openLocalFile": "打开本地文件",
  "HeaderDropdown.exportProjectAsJson": "保存到本地",
  "HeaderDropdown.importExtension": "导入自定义控件",
  // [CoCo Next] 添加对更多控件的支持
  "HeaderDropdown.unsafeCoCoExtension": "CoCo 控件",
  // "HeaderDropdown.unsafeCoCoExtension": "CoCo 控件（兼容 CoCo，不安全）",
  "HeaderDropdown.importExtensionSuccess": "已导入「{title}」控件，请到拓展控件添加",
  "HeaderDropdown.newProject": "新建",
  "HeaderDropdown.openProject": "打开",
  "HeaderDropdown.saveAs": "另存为",
  "HeaderDropdown.history": "还原历史版本",
  "HeaderDropdown.showRuler": "显示标尺",
  // [CoCo Next] 调整设置
  "HeaderDropdown.stage": "舞台",
  "HeaderDropdown.hideRuler": "隐藏标尺",
  "HeaderDropdown.showWidgetAndStage": "显示舞台",
  "HeaderDropdown.hideWidgetAndStage": "隐藏舞台",
  "HeaderDropdown.display": "显示",
  // [CoCo Next] 添加全屏和缩小显示
  "HeaderDropdown.fullscreen": "全屏",
  "HeaderDropdown.exitFullscreen": "退出全屏",
  "HeaderDropdown.zoomOut": "缩小显示",
  "HeaderDropdown.run": "运行",
  "HeaderDropdown.restoreZoomOut": "正常显示",
  "HeaderDropdown.plugin": "插件（实验性）",
  "projectDialog.newProject": "新建作品",
  "projectDialog.myProject": "我的作品",
  "ChromeTips.compatibility": "当前浏览器可能存在兼容问题，无法正常运行CoCo请使用谷歌Chrome浏览器打开该网页",
  "ChromeTips.download": "下载Chrome",
  "MyProject.ago": "前",
  "MyProject.year": "年",
  "MyProject.month": "月",
  "MyProject.day": "日",
  "MyProject.hour": "小时",
  "MyProject.minute": "分钟",
  "MyProject.yesterday": "昨天",
  "MyProject.theDayBeforeYesterday": "前天",
  "MyProject.just": "刚刚",
  "MyProject.justSaved": "刚刚保存过",
  "MyProject.saveWarnTips": "记得保存当前作品哦！",
  "MyProject.newSaveTips": "保存作品，下次可在我的作品中打开哦！",
  "MyProject.autoSaveErrorTips": "当前网络不佳，自动保存失败",
  "MyProject.notSaved": "该作品未保存到云端",
  "MyProject.lastSaved": "上次保存",
  "MyProject.self": "我创建的",
  "MyProject.coll": "我参与的",
  "MyProject.published": "已发布",
  "MyProject.unpublished": "未发布",
  "MyProject.noCreateProjectTips": "你还没有创建作品哦",
  "MyProject.noCollProjectTips": "你还没有协作作品哦",
  "MyProject.noPublishProjectTips": "你还没有发布作品哦",
  "MyProject.deleteProject": "删除",
  "MyProject.deleteCollProject": "退出协作",
  "MyProject.deleteProjectError": "删除失败",
  "MyProject.deleteProjectSuccess": "作品移至回收站",
  "MyProject.cancelPublic": "取消发布",
  "MyProject.confirmDeleteProjectTitle": "是否删除 “{name}” 作品？",
  "MyProject.confirmDeleteProjectDescription": "删除后, 作品将无法恢复",
  "MyProject.confirmDeleteCollProjectDescription": "删除后, 协作者将无法打开该作品",
  "MyProject.quitCollWorkTitle": "是否退出 “{name}” 协作？",
  "MyProject.quitCollWorkConfirmText": "退出",
  "MyProject.quitCollWorkDescription": "退出后, 该作品将不在作品管理页中显示",
  "MyProject.projectHasDeleted": "你要打开的作品已被删除",
  "MyProject.projectHasNoRermission": "你没有权限打开该作品，将打开默认作品",
  // [CoCo Next] 添加插件
  "PluginDialog.installed": "已安装",
  "PluginDialog.shop": "商城",
  "PluginDialog.settings": "设置",
  "PluginDialog.develop": "开发",
  "PluginList.search": "搜索插件",
  "PluginList.noPlugin": "没有插件",
  "PluginList.notSelected": "选择一个插件，在此处查看插件的更多信息",
  "PluginShop.latest": "最新",
  "PluginShop.views": "最热",
  "PluginShop.showInNewTab": "在新标签页查看",
  "PluginDevelop.inputURL": "请输入插件地址",
  "PluginDevelop.addPlugin": "添加插件",
  "PluginDevelop.addPluginSuccess": "成功添加「{name}」插件",
  "PluginDevelop.addPluginFailed": "添加插件失败",
  "PluginDetail.install": "安装",
  "PluginDetail.installing": "正在安装……",
  "PluginDetail.remove": "移除",
  "PluginDetail.readmeLoading": "加载中……",
  "PluginDetail.readmeLoadFailed": "加载失败：{message}",
  "PluginManager.loadFiled": "加载失败",
  "PluginManager.loadFiledMessage": "加载失败：{message}",
  "PluginManager.installPluginSuccess": "已安装插件「{name}」",
  "PluginManager.installPluginFailed": "安装插件失败",
  "PluginManager.removePluginFinished": "已移除插件「{name}」",
  "PluginManager.needsInstallTitle": "需要安装插件「{name}」",
  "PluginManager.needsInstallContent": "该作品依赖插件\n名称： {name}\n包名：{packageName}\n作者：{authorName}\n介绍：{description}\n是否安装该插件？\n⚠️ 安装插件具有安全风险，请确认安全再安装！",
  "PluginManager.confirmInstall": "安装",
  "PluginManager.rejectInstall": "安装",
  "StorageDialog.defaultData": "初始数据",
  addBroadcastTitle: "{scene}.新建广播",
  addCurrentScreenIndexTitle: "屏幕{currentScreenIndex}：新建广播",
  addBroadcastTitlePlaceholder: "请输入广播名称",
  addBroadcast: "新建广播",
  broadcastExisted: "命名的广播已存在",
  broadcastCannotBeSpace: "输入字符不能全为空格",
  broadcastInvalid: "存在非法字符",
  addBroadcastOnlyCurrentScreenTips: "* 创建的广播只能在当前屏幕使用",
  screen: "屏幕",
  // [CoCo Next] 移除屏幕数量上线
  screeMaxSize: "屏幕数量已达到 CoCo 上限，虽然 CoCo Next 允许你继续添加屏幕",
  changeIcon: "更换图标",
  blankInputValue: "输入不能为空",
  copyAndPaste: "复制并粘贴",
  copyTo: "复制到",
  reminder: "提示语",
  style: "样式",
  input: "输入框",
  inputText: "文本内容",
  canvas: "画布",
  defaultCanvasWidgetTitle: "画布",
  brush: "画笔",
  defaultBrushWidgetTitle: "画笔",
  defaultActorWidgetTitle: "角色",
  canvasAddBackgroundImage: "添加",
  canvasReplaceBackgroundImage: "替换",
  actor: "角色",
  actorAddStyle: "添加造型",
  actorScale: "比例大小",
  rotation: "方向",
  flip: "翻转",
  styleAction: "造型动作",
  "actor.interval": "间隔",
  "actor.setPivot": "设置轴心点",
  "actor.resetPivot": "重置轴心点",
  "actor.editProperty": "编辑属性",
  "actor.editActionStyle": "编辑动作造型",
  "ActorStyleDialog.dialogTitle": "角色设计",
  "ActorStyleDialog.addStyle": "添加帧",
  "ActorStyleDialog.addAction": "添加动作",
  "ActorStyleDialog.actionName": "动作",
  "ActorStyleDialog.defaultActionName": "动作",
  "ActorStyleDialog.currentStyle": "当前为默认造型",
  "ActorStyleDialog.defaultStyle": "默认造型",
  "ActorStyleDialog.setCurrentStyle": "设为默认造型",
  "StageToast.addCanvasWidgetTips": "请先添加画布喵~",
  "StageToast.addActorToCanvasTips": "添加失败，请放置在画布中",
  "StageToast.addLimitedWidgetTips": "只能添加一个{widgetTitle}控件~",
  procedureDialogTitle: "函数",
  procedureDialogPlaceholder: "请输入函数名",
  preservedProcedureName: "名称不可只包含函数或function",
  procedureNameExists: "函数名已经存在",
  emptyProcedureName: "函数名不能为空",
  parameterDialogTitle: "参数",
  parameterDialogPlaceholder: "请输入参数名",
  parameterExists: "参数已经存在",
  emptyParameterName: "参数名不能为空",
  back: "返回",
  file: "文件",
  help: "帮助",
  setting: "设置",
  courseVideo: "入门教程",
  studyCourseVideo: "教程视频",
  moreCourseTips: "更多精彩，敬请期待",
  coursePlayingTips: "当前已处于教程模式中",
  seeTutorial: "帮助文档",
  feedback: "问题反馈",
  aboutUs: "关于我们",
  releaseInfo: "版本更新",
  projectTitlePlaceholder: "请输入作品名称",
  isEmptyProjectTitle: "输入不能为空",
  newProjectTitle: "新的作品",
  whetherKeepWorksTitle: "即将打开新作品，是否保存当前作品？",
  whetherKeepWorksTitleWhenBackHome: "即将返回主页，是否保存当前作品？",
  whetherKeepWorksTitleWhenOpenCourse: "即将打开教程作品，是否保存当前作品？",
  whetherKeepWorksDescription: "建议点击保存作品，防止作品丢失",
  iconLib: "图标库",
  // [CoCo Next] 添加原始登录
  originalLogin: "原始登录",
  // [CoCo Next] 添加原始账号管理
  originalAccountSetting: "原始账号设置",
  login: "登录",
  logout: "退出登录",
  accountSetting: "账号设置",
  serviceAgreement: "服务协议",
  allType: "全部",
  basic: "基础",
  society: "社交",
  media: "媒体",
  initialData: "初始数据",
  resetData: "重置为初始数据",
  noData: "暂无数据",
  storageDialogTitle: "微数据库-初始数据",
  deprecatedStorageDialogTips: "* 值有字符串、数字两种类型，仅数字可修改类型",
  storageDialogTips: "* 微数据库存储的值均为字符串类型",
  isRepeatMicroDataKey: "当前键和其他键重名，请修改",
  repeatKeyToastMsg: "当前键名已存在",
  key: "键",
  storage: "微数据库",
  storageExisted: "数据库已存在",
  storageKeyExisted: "键已存在",
  addDocument: "新建微数据库",
  addDocumentPlaceholder: "请输入微数据库名称",
  addDocKey: "新建键",
  addDocKeyPlaceholder: "请输入键名称",
  keyValueTotal: "键值对总数",
  keyOverTheMaximum: "添加失败，最多支持1000个键值对",
  value: "值",
  storageItemNumber: "数字",
  storageItemString: "字符串",
  giveUp: "放弃",
  giveUpTitle: "放弃本次编辑的内容吗?",
  giveUpTips: "退出后编辑的内容将不会保存，请谨慎操作",
  deleteDocTitle: "删除数据库 “{name}” 吗?",
  deleteImageFileTitle: "删除图片 “{name}” 吗?",
  deleteImageGroupFileTitle: "删除图片组 “{name}” 吗?",
  deleteDocTips: "使用该数据库的积木将会失效?",
  deleteImageFileTips: "图片已经被控件/积木应用，删除后可能导致作品异常",
  deleteImageGroupFileTips: "图片组已经被控件/积木应用，删除后可能导致作品异常",
  noSelectDoc: "未选中数据库",
  nameIsEmpty: "名称不能为空",
  clearProjectRuntimeDataSuccess: "微数据库重置成功",
  unnamed: "未命名",
  cloudDatabase: "云微数据库",
  addCloudDatabase: "新建云微数据库",
  addCloudDatabasePlaceholder: "请输入云微数据库名称",
  cloudDatabaseExisted: "云微数据库已存在",
  cloudDatabaseMaxCountTips: "无法创建，每个用户只能创建10个云微数据库",
  cloudDbListNetworkErrorTips: "网络问题，无法获取所有云微数据库",
  cloudDbAddNetworkErrorTips: "网络问题，无法创建云微数据库",
  cloudDbUpdateNetworkErrorTips: "网络问题，无法更新云微数据库名称",
  cloudDbDeleteNetworkErrorTips: "网络问题，无法删除云微数据库",
  cloudDbAddKeyNetworkErrorTips: "网络问题，无法创建键值对",
  cloudDbUpdateKeyNetworkErrorTips: "网络问题，无法更新键值对",
  cloudDbDeleteKeyNetworkErrorTips: "网络问题，无法删除键值对",
  cloudDbOverTheMaxKeyTips: "添加失败，最多支持2000个键值对",
  cloudDbNameConflictTitle: "云微数据库名称重复",
  cloudDbNameConflictDescription: "<p>作品中部分云微数据库与账号中云微数据库名字重复系统将自动修改作品中该部分云微数据库名称</p><p><b>修改示例：“账号” 更改为 “账号1”</b></p>",
  cloudDbCountOverflowTitle: "云微数据库数量超过上限",
  cloudDbCountOverflowDescription: "<p>作品中包含 <b>{workDbCount}</b> 个云微数据库，账号已建立 <b>{selfDbCount}</b> 个云微数据库。</p>单个账号可建立的云数据库上限为 {maxCount}，打开后将无法正确显示该作品的云微数据库相关信息。",
  cloudDbUserNotLoginTitle: "用户未登录",
  cloudDbUserLogin: "登录",
  cloudDbUserCancelLogin: "暂不登录",
  cloudDbUserNotLoginDescription: "该作品包含云微数据库初始值，登录后即可正常使用，是否立刻登录？",
  notHavePermissionToAddCloudDb: "非作品作者无法添加云数据库",
  notHavePermissionToDeleteCloudDb: "非作品作者无法删除云数据库",
  httpClient: "web客户端",
  addHttpClient: "新建web客户端",
  addHttpClientPlaceholder: "请输入web客户端名称",
  httpClientNameRepeat: "web客户端名已存在",
  "cloudSpace.cloudDict": "云字典",
  "cloudSpace.cloudTable": "云数据表",
  "cloudSpace.cloudSpace": "源码云空间",
  "cloudSpace.DataSource": "云数据源",
  "cloudSpace.ChooseDataSource": "选择数据源",
  "cloudSpace.newDict": "新建云字典",
  "cloudSpace.newTable": "新建云数据表",
  "cloudSpace.login": "登录",
  "cloudSpace.cancelLogin": "暂不登录",
  "cloudSpace.NotLoginTitle": "用户未登录",
  "cloudSpace.notLoginDescription": "当前作品使用到了云数据源，未登录则无法使用该功能",
  "cloudSpace.onlyAuthorCanEdit": "仅创作者可以操作",
  "cloudSpace.dataSourceNotExist": "数据源不存在",
  "cloudSpace.dataSourceNotExistDesc": "以下控件绑定的云数据源发生异常（数据源不存在），请重新绑定",
  "cloudSpace.dataSourceExceedLimitError": "以下控件绑定的云数据源创建失败(每个用户最多创建20个{type}，当前已达上限)，请释放云空间存储容量后再次尝试",
  "cloudSpace.needLogin": "登录使用",
  "cloudSpace.outMaxLimit": "部分数据源容量已达上限，请及时清理数据",
  "cloudSpace.outWarnLimit": "部分数据源容量即将达到上限，请及时清理数据",
  "cloudSpace.NotBindDataSource": "未绑定数据源",
  "cloudSpace.emptyKeysData": "当前键为空",
  "cloudSpace.fetchDataFailed": "数据获取失败",
  "cloudSpace.emptyColumnsData": "当前列为空",
  waitForAssetUploading: "请先等待所有资源上传",
  "package.packageProjectDialogTitle": "作品打包",
  "package.projectTitle": "应用名称：",
  "package.plateFormTips": "仅支持Android平台",
  "package.apkNameMaxLengthTips": "最多支持20个中文或40个英文字符",
  "package.projectIcon": "应用图标：",
  "package.recommendProjectIcon": "推荐图标",
  "package.projectSplashImage": "启动图：",
  "package.recommendSplashImage": "推荐图",
  "package.replace": "替换",
  "package.projectIconSizeTips": "推荐尺寸：512×512",
  "package.projectSplashSizeTips": "推荐尺寸：720×1280",
  "package.uploadIconFailed": "上传应用图标失败，请重试",
  "package.uploadSplashFailed": "上传启动图失败，请重试",
  "package.iconMimeTypeNotSupport": "icon：仅支持上传 png、jpg、jpeg、bmp格式（修改文件后缀名，无法实现格式转换）",
  "package.splashMimeTypeNotSupport": "启动图：仅支持上传 png、jpg、jpeg、bmp格式（修改文件后缀名，无法实现格式转换）",
  "package.checkSplashFailed": "图片审核失败：请确认上传的图片内容无敏感信息",
  "package.isPackaging": "打包中...",
  "package.packageComplete": "打包完成",
  "package.packagePendingText": "正在排队中",
  "package.packagePending": "正在打包中，请打包完成后再操作",
  "package.cancelPackage": "打包正在进行中，确定中止进程？",
  "package.copy": "复制链接",
  "package.copied": "已复制",
  "package.cancel": "确定",
  "package.apkNameInvalid": "应用名称只支持数字，字母，汉字，空格",
  "package.appidCopied": "APP ID已复制",
  "package.download": "下载安装包",
  "package.downloaded": "已下载安装包",
  "package.apkText": "手机浏览器扫描二维码，可直接下载安装APK",
  "package.buildFailedTitle": "打包失败，可能出现以下问题",
  "package.buildFailedTips1": "网络异常：请选择稳定的网络",
  "package.buildFailedTips2": "代码错误：请确保程序运行后，无报错反馈",
  "package.buildFailedTips3": "资源过大：建议从项目资源中删除不再使用的文件",
  "package.buildFailedTips41": "其他问题：请在 ",
  "package.buildFailedTips42": " 中联系我们",
  "package.networkErrorTitle": "网络不给力，打包失败",
  "package.networkErrorTips1": "网络恢复后，可再次尝试",
  "package.networkErrorTips2": "建议将作品 ",
  "package.networkErrorTips3": "，避免数据丢失",
  "package.deletePackage": "请确认是否删除本次打包内容？",
  "project.saving": "作品正在保存...",
  "saveProject.successTips": "作品保存成功",
  "saveProject.failDialogTitle": "网络不给力，保存失败",
  "saveProject.failDialogTips1": "网络恢复后，可再次尝试",
  "saveProject.failDialogTips2": "建议将作品 ",
  "saveProject.failDialogTips3": "，避免数据丢失",
  "saveProject.failDialogSaveLocalTips": "保存到本地",
  "ProjectSaveProgressDialog.cancelSave": "取消保存",
  "ProjectSaveProgressDialog.content": " 正在保存中，当前网络不佳，稍等片刻",
  importImageFailTitle: "个图片上传失败",
  importSoundFailTitle: "个声音上传失败",
  importFailDetail: "详情",
  close: "关闭",
  know: "我知道了",
  emptyImageLibraryTips1: "可同时上传多张图片",
  emptyImageLibraryTips2: "（ jpg、jpeg、png、bmp、svg、gif ）",
  emptyImageLibraryTips3: " *图片名称不能为空",
  emptyImageLibraryTitle: "将图片拖拽到此处",
  emptyIconLibraryTips1: "*支持同时上传多张图标",
  emptyIconLibraryTips2: " *支持格式：svg",
  emptyIconLibraryTips3: " *图标名称不能为空",
  emptyIconLibraryTitle: "拖拽图标直接上传",
  uploadImageByLink: "网络链接",
  uploadByOffice: "官方素材",
  uploadByMine: "我的素材",
  addImageFile: "添加图片",
  importImageSuccess: "图片上传成功",
  emptyImageLibrary: "没有对应的素材哟",
  sound: "声音",
  "sound.all": "全部",
  "sound.effect": "音效",
  "sound.music": "音乐",
  allSound: "所有声音",
  uploadFileByLocal: "本地上传",
  tooLargeSound: "声音文件不能大于10MB",
  soundNameError: "声音名称不能为空",
  importSoundSuccess: "声音上传成功",
  deleteSoundFileTitle: "删除声音 “{name}” 吗?",
  deleteSoundFileTips: "声音已经被控件/积木应用，删除后可能导致作品异常",
  deleteIconFileTitle: "删除图标 “{name}” 吗?",
  deleteIconFileTips: "图标已经被控件/积木应用，删除后可能导致作品异常",
  addFileHelp: "上传帮助",
  addFileHelpStep1: "1.本地文件拖动到下方可上传",
  addFileHelpStep2: "2.支持同时上传多个文件",
  emptySoundLibraryTitle: "拖拽声音直接上传",
  emptySoundLibraryTips1: "*支持同时上传多个声音",
  emptySoundLibraryTips2: "*支持格式：mp3、wav、oga、aac",
  emptySoundLibraryTips3: "*声音文件名称不能为空",
  emptySoundLibraryTips4: "*声音文件不能大于10MB",
  renameFileNameRepeatTips: "已存在相同的名称",
  soundBlockNoSelectFileMessage: "播放声音积木没有选择音频文件",
  soundBlockValueTypeErrorMessage: "所嵌入积木的返回值不是数字类型",
  radio: "单选框",
  radioOptionsContent: "选项内容",
  openHeadline: "有",
  closeHeadline: "无",
  headline: "题干",
  defaultHeadlineContext: "请输入题干",
  defaultOption1: "选项1",
  defaultOption2: "选项2",
  addOption: "加选项",
  deleteOption: "减选项",
  option: "项",
  checkbox: "多选框",
  url: "网址",
  pleaseInput: "请输入",
  refresh: "刷新",
  switch: "开关",
  "switch.custom": "自定义开关",
  "switch.replaceImage": "替换图片",
  "switch.close": "关闭",
  "switch.open": "开启",
  slider: "滑动条",
  direction: "方向",
  horizontal: "水平",
  vertical: "垂直",
  defaultValue: "默认值",
  numberValue: "数值",
  initialValue: "初始值",
  maxValue: "最大值",
  minValue: "最小值",
  gap: "间距",
  "slider.background": "背景框",
  "slider.template": "模版",
  "slider.image": "图片",
  "slider.custom": "自定义滑动条",
  "slider.preview": "合成预览",
  "slider.replaceImage": "替换图片",
  "slider.backgroundImage": "滑条底图",
  "slider.trackImage": "滑条顶图",
  "slider.handleImage": "滑块",
  "slider.handleSize": "滑块大小",
  "slider.maxValueEqualMinValue": "{title}的最大值与最小值相等",
  "slider.stepGreaterThanRange": "{title}间距超过取值范围",
  "DataWatch.pin": "置顶",
  "DataWatch.unpin": "取消置顶",
  dataWatch: "数据观测",
  customize: "自定义",
  projectNotHasVariableTips: "当前作品没有变量哦",
  projectNotHasListTips: "当前作品没有列表哦",
  dataWatchTopCurrentScreen: "当前屏幕置顶",
  dataWatchAddCustomizeTips: "添加到自定义",
  dataWatchRemoveCustomizeTips: "移出自定义列表",
  "DataWatch.addData": "添加数据",
  "DataWatch.search": "检索数据名称",
  "DataWatch.searchEmpty": "未检索到相关数据",
  "DataWatch.noData": "没有可添加的数据",
  "DataWatch.empty": "暂未添加数据哦~",
  "DataWatch.unable": "暂无可添加的数据",
  "DataWatch.cancel": "取消",
  "DataWatch.confirm": "确定",
  "colorPicker.history": "最近使用",
  "colorPicker.more": "更多颜色",
  "colorPicker.eyeDropperTips": "请使用高于95版本的谷歌浏览器吸色",
  consoleSystemLabel: "系统",
  print: "积木打印",
  customError: "积木报错",
  customWarning: "积木预警",
  consoleError: "错误",
  consoleWarning: "警示",
  consoleLog: "日志",
  consolePrint: "打印",
  consolePanel: "控制台",
  consoleFilter: "筛选",
  consolClear: "清除",
  functionIsUndefined: "该函数未定义",
  noUndef: "该参数只能在对应事件积木下使用",
  noReturnFunction: "该定义函数积木没有返回值",
  branchReturnFunction: "该函数有部分分支没有返回值",
  returnNotInFunction: "函数返回模块只能在函数中使用",
  parameterNotInFunction: "参数积木只能在对应的函数中使用",
  paramNotInContext: "参数积木只能在对应的作用域使用",
  loopControlOutsideLoop: "该积木块只能在循环中使用",
  widgetNotExists: "积木无对应控件",
  theBlockHasBeRemoved: "对应积木已被删除",
  "OT.inviteFriend": "邀请好友",
  "OT.creator": "创建者",
  "OT.copyCollInvitationUrl": "邀请好友协作",
  "OT.collJurisdiction": "当前邀请的协作者权限为",
  "OT.url": "链接",
  "OT.generating": "生成中",
  "OT.editable": "可编辑",
  "OT.copyLink": "复制链接",
  "OT.coll": "协作",
  "OT.isBuildingCollWork": "正在建立链接，同步协同内容...",
  "OT.urlIsInvalid": "链接已经失效",
  "OT.urlIsInvalidDetail": "该链接已经失效啦，请联系分享者重新生成邀请链接~",
  "OT.know": "我知道了",
  "OT.netIsError": "网络异常，协作链接失败",
  "OT.netIsErrorDetail": "网络原因无法进入协作，请检查网络是否正常",
  "OT.collPeopleCount": "人正在协作",
  "OT.currentProjectBeDeleteTitle": "当前作品已被创建者删除",
  "OT.currentProjectBeDeleteDescription": "作品已被删除，请打开新作品进行创作",
  "OT.canNotFindProjectTitle": "加载作品失败",
  "OT.canNotFindProjectDescription": "当前作品加载失败, 请打开新作品进行创作",
  "OT.inviteLinkOverdueDescription": "该链接已失效，请联系分享者重新分享",
  "OT.editPermissionLostTitle": "你没有权限编辑这个作品",
  "OT.editPermissionLostDescription": "回到编辑器内看看吧～",
  "OT.copySuccess": "复制成功",
  "OT.permissionChangeToReadOnly": "创建者将你的权限改为只能查看",
  "OT.permissionChangeToEdit": "创建者将你的权限改为可以编辑",
  "OT.expiration": "邀请链接有效期为7天",
  // [CoCo Next] 添加协作安全警告
  "OT.secure": "⚠ 请确保只将协作链接分享给你信任的人，以免造成损失",
  "OT.editor": "编辑者",
  "OT.reader": "查看者",
  "OT.editorRules": "可对控件、代码进行编辑",
  "OT.readerRules": "不可编辑",
  "OT.dialogCanEdit": "可编辑",
  "OT.dialogReadOnly": "可查看",
  "OT.dialogRemove": "移出协作",
  "OT.edit": "可编辑",
  "OT.readonly": "可查看",
  "OT.revert": "创建者正在回退版本中...",
  "OT.tips": "提示",
  globalVariable: "全局变量",
  screenVariable: "屏幕变量",
  globalArray: "全局列表",
  screenArray: "屏幕列表",
  "WidgetForm.opacity": "不透明度",
  "WidgetForm.title": "控件",
  "BlockEditor.undo": "撤销",
  "BlockEditor.redo": "重做",
  "BlockEditor.dec": "缩小",
  "BlockEditor.percent": "重置为100%",
  "BlockEditor.inc": "放大",
  "BlockEditor.cleanup": "整理积木",
  "Publish.publishFail": "发布失败",
  "Publish.publishSuccess": "发布成功",
  "Publish.publish": "发布",
  "Publish.publishName": "作品名称",
  "Publish.inputPublishName": "请输入作品名称",
  "Publish.publishDescription": "作品介绍",
  "Publish.inputPublishDescription": "向大家介绍你的作品，如果你的作品是基于他人作品的再创作，或者从他人中得到灵感，别忘记感谢原作者哦~",
  "Publish.publishOperation": "操作说明",
  "Publish.inputPublishOperation": "给你的作品写一个体验指南，并教大家如何操作吧~",
  "Publish.workCover": "作品封面",
  "Publish.changeWorkCover": "更换作品封面",
  "Publish.share": "分享",
  "Publish.shareToCommunity": "分享到社区",
  "Publish.shareToOthers": "分享到QQ/微信",
  "Publish.shareQrCode": "扫码分享",
  "Publish.creatingQrCode": "二维码生成中...",
  "Publish.refreshQrCode": "刷新二维码",
  "Publish.moreSettings": "更多设置",
  "Publish.shareTitle": "分享标题",
  "Publish.shareDescription": "分享说明",
  "Publish.inputShareDescription": "我用CoCo编辑器做了个很棒的APP，快来看看吧！",
  "Publish.shareQRError": "二维码生成失败请检查网络",
  "Publish.copyLinkSuccess": "链接已复制到粘贴板",
  "Publish.copyLinkFailure": "链接复制失败",
  "Publish.projectSaveFail": "作品保存失败，请重试",
  "Publish.copyShareLink": "复制链接",
  "Publish.shareLinkCopied": "复制成功",
  "Publish.coverImageUploadFail": "封面图上传失败，请重试",
  "History.fallback": "回退",
  "History.overview": "预览",
  "History.autoSave": "自动保存",
  "History.save": "手动保存",
  "History.historyVersion": "查看历史记录",
  "History.noVersion": "暂无历史版本",
  "History.fetchError": "获取历史数据失败，请稍后再试",
  "History.revertSuccess": "回退成功",
  "Play.widgetNotSupportsWebPlatform": "{widgetTypeNames}控件暂不支持网页端运行，需要打包后才能使用",
  "Play.widgetNotSupportsForbiddenKeywords": "自定义控件“{widgetTypeNames}”使用到了非法关键词，需移除控件才能继续使用。",
  "emulator.shake": "摇晃",
  "emulator.rotation": "旋转",
  "emulator.position": "移动",
  "emulator.dialCall": "拨出电话",
  "emulator.receiveCall": "收到来电",
  "emulator.receiveSms": "收到短信",
  "emulator.callRefuse": "拒绝",
  "emulator.callConnect": "接听",
  "emulator.callEnd": "挂断",
  "emulator.callEndByOtherSide": "对方挂断",
  "emulator.callConnectByOtherSide": "对方接听",
  "emulator.callByOtherSide": "对方拨打",
  "emulator.noCall": "暂无来电",
  "emulator.phoneNumber": "电话号码",
  "emulator.onRinging": "正在呼叫...",
  "emulator.onCalling": "正在通话...",
  "emulator.incomingNumber": "来电号码",
  "emulator.incomingNumberPlaceHolder": "请输入来电号码",
  "emulator.callNumber": "拨打号码",
  "emulator.smsNumber": "发送者号码",
  "emulator.smsContent": "短信内容",
  "emulator.smsNumberPlaceHolder": "请输入发送者号码",
  "emulator.smsSendNumberPlaceHolder": "请输入号码",
  "emulator.smsContentDefault": "Hello！这是一条默认短信。",
  "emulator.smsContentPlaceHolder": "请输入短信内容",
  "emulator.sms": "短信",
  "emulator.now": "现在",
  "emulator.smsReceiver": "收信人",
  "Resource.upload": "本地上传",
  "Resource.ResourceMall": "素材商城",
  "Resource.ProjectLibrary": "项目资源",
  "Resource.ImageLibrary": "图片库",
  "Resource.SoundLibrary": "声音库",
  "Resource.IconLibrary": "图标库",
  "Resource.Image": "图片",
  "Resource.Sound": "声音",
  "Resource.Icon": "图标",
  "Resource.Clear": "清空",
  "Resource.Add": "添加",
  "Resource.Cancel": "取消",
  "Resource.Apply": "应用",
  "Resource.Replace": "替换",
  "Resource.Added": "已添加",
  "Resource.search": "搜索素材",
  "Resource.HowFindMaterial": "如何寻找素材？",
  "Webview.widgetName": "网页框",
  "WidgetValidators.string.notEmpty": "{label}不能为空",
  "WidgetValidators.string.maxLength": "{label}的值超出最大长度{ruleValue}，当前值{inputValue}",
  "WidgetValidators.string.minLength": "{label}的值不能小于最小长度{ruleValue}，当前值{inputValue}",
  "WidgetValidators.number.greaterThan": "{inputValue}不能小于{ruleValue}",
  "WidgetValidators.number.lessThan": "{inputValue}不能大于{ruleValue}",
  "WidgetValidators.number.isInteger": "{inputValue}不符合整数要求",
  "Workspace.ContextMenu.blockToImage": "生成图片",
  "Workspace.ContextMenu.jumpToProcDef": "定位到定义函数",
  "Workspace.blockDragDeleteAreaTips": "松手即可删除积木",
  "QR_SCANNER_WIDGET.PlatformNotSupport": "请打包后使用摄像头扫描二维码功能",
  "ScanQrCode.tip": "请将二维码对准，即可自动扫描",
  "ScanQrCode.Error.UnexpectedError": "未知错误",
  "ScanQrCode.Error.CameraAccessDenied": "用户未授予相机权限",
  "ScanQrCode.Error.CameraAccessRestricted": "无法获得相机权限",
  "ScanQrCode.Error.BackCameraUnavailable": "后置摄像头不可用",
  "ScanQrCode.Error.FrontCameraUnavailable": "前置摄像头不可用",
  "ScanQrCode.Error.CameraUnavailable": "摄像头不可用",
  "ScanQrCode.Error.ScanCanceled": "扫描被取消",
  "ScanQrCode.Error.LightUnavailable": "闪光灯不可用",
  "ScanQrCode.Error.SettingsUnavailable": "设置不可用",
  "ScanQrCode.Error.NotFound": "未找到二维码",
  "cloudDBPublishDialog.jump": "跳过教程",
  "cloudDBPublishDialog.know": "去了解",
  "cloudDBPublishDialog.then": "下一步",
  "cloudDBPublishError.uniqueColumnError": "同步唯一列失败，正式环境已去掉唯一列设置",
  "cloudDBPublishError.migrateError": "数据同步失败，请稍后再试",
  "cloudDB.DeleteWidgetsTips": "移除后，作品中不存在该数据库，但是没有真正删除数据库\n如果需要真正删除数据库，请打开数据管理",
  "axios.weakNetworkTips": "当前网络不佳，请检查网络后重试",
  "download.success": "下载成功",
  "download.failed": "下载失败",
  "download.offline": "网络连接失败",
  "object.createNewObject": "新建字典",
  "object.screenObject": "屏幕字典",
  "object.globalObject": "全局字典",
  "object.createNewObjectNamePlaceholder": "请输入字典名称",
  "object.nameRepeat": "字典名已存在",
  "object.editObjectList": "编辑字典",
  "object.keyRepeat": "当前键名已存在",
  "material.materialNotFound": "没有找到相关素材，换个姿势再搜索一次吧～",
  "RichTextEditor.inputPlaceholder": "请输入内容",
  "RichTextEditor.editDialogTitle": "富文本编辑"
}), l)

export type Language = "zh-CN"

export const locale = "zh-CN"

export const messages: Record<Language, Record<string, string>> = {
  "zh-CN": u
}

function f(e) {
  for (var t in e) if (messages[t]) {
    Object.assign(messages[t], e[t])
  }
}
var h = createIntl({
  locale,
  messages: messages[locale]
})

export function format(language: Language, key: string, args?: Record<string, string>): string {
  let result: string = messages[language]?.[key] || messages[locale]?.[key]
  if (typeof result === "string" && args) {
    result = result.replace(/{([^}]*)}/g, (__substring, key): string => {
      let value: string | undefined = args[key]
      return undefined === value ? "" : value
    })
  }
  return result
}

function g(e, t, n) {
  var r = /^%{COCO_([\w/]+)}$/.exec(t)
  return r && r[1] ? format(e, r[1], n) : t
}
function _(e, t) {
  t = t || {}
  return h.formatMessage({
    id: e
  }, Module_6.a(Module_6.a({}, t), {}, {
    p: function () {
      for (var arguments$length = arguments.length, t = new Array(arguments$length), n = 0; n < arguments$length; n++) {
        t[n] = arguments[n]
      }
      return React.a.createElement("p", null, t)
    },
    span: function () {
      for (var arguments$length = arguments.length, t = new Array(arguments$length), n = 0; n < arguments$length; n++) {
        t[n] = arguments[n]
      }
      return React.a.createElement("span", null, t)
    },
    b: function () {
      for (var arguments$length = arguments.length, t = new Array(arguments$length), n = 0; n < arguments$length; n++) {
        t[n] = arguments[n]
      }
      return React.a.createElement("b", null, t)
    }
  }))
}
export default f
